export function convertToSeconds(unit: string, value: string) {
  switch (unit.toLowerCase()) {
    case "seconds":
      return Number(value);
    case "minutes":
      return Number(value) * 60;
    case "hours":
      return Number(value) * 3600;
    case "days":
      return Number(value) * 86400;
    default:
      return 0;
  }
}
